import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

const closeAiPhotoGenerationResetModal = () => closePopupHelper(popupNames.AI_GENERATION_RESET_MODAL);

export const openAiPhotoGenerationResetModal = () =>
    openPopupHelper({ popupName: popupNames.AI_GENERATION_RESET_MODAL, onClose: closeAiPhotoGenerationResetModal });
